// Elements matching these selectors will trigger `syncQuantityInputs` when they are clicked
var clickTriggers = [ '.plus-qty', '.minus-qty' ]
 
 
var balanceShadowVariantInputs = function(input){
  if (window.BOLD && BOLD.common && BOLD.common.cartDoctor) {
    BID = 0;
    qty = input.value;
    key = input.dataset.id;
    cart = BOLD.common.cartDoctor.rawCart;
    for (i = 0; i < cart.items.length; i++) {
      if (key == cart.items[i].key &&
          cart.items[i].properties &&
          cart.items[i].properties._boldBuilderId &&
          cart.items[i].properties._boldVariantIds &&
          !cart.items[i].properties._boldVariantQtys) {
        //We have a base item with no complex quantity conditions, add the BID to the array
        BID = cart.items[i].properties._boldBuilderId;
      }
    }
    //BID should be set, match the quantity of priced options
    if (BID) {
      for (i = 0; i < cart.items.length; i++) {
        if (cart.items[i].properties &&
            cart.items[i].properties._boldBuilderId == BID &&
            !cart.items[i].properties._boldVariantIds) {
          dependents = document.querySelectorAll('input[id="updates_'+ cart.items[i].key +'"]');
          dependents.forEach(function(dep){
            dep.value = qty;
            dep.setAttribute("value", qty);
          });
        }
      }
    }
  }
}
 
 
var syncQuantityInputs = function() {
  var inputs = document.querySelectorAll('input[name="updates[]"]');
  for (var i in inputs) {
    if (typeof inputs[i] === "object") {
      balanceShadowVariantInputs(inputs[i])
    }
  }
  console.log('[Bold] Shadow Variant Inputs Synced')
}
 
// Use document level listeners so that the input change is complete because if it's not we will set dependant values to the old value
document.addEventListener('change', function(ev) {
  if (ev.target.nodeName === "INPUT") {
    syncQuantityInputs()
  }
})
document.addEventListener('click', function(ev) {
  if (ev.target.matches(clickTriggers)) {
    syncQuantityInputs()
  }
})